import type { AgentServiceAccount, OrgCategory } from "../../generated/core-api";

export function getServiceAccountLabel(
  account: Pick<AgentServiceAccount, "description">,
): string {
  const description = account.description?.trim();
  return description || "Untitled service account";
}

export type OrgNameRef = {
  id: string;
  name: string;
  category: OrgCategory;
};

export function extraOrgRoleLabel(
  role: { org_id: string; org_category: string; role: string },
  orgs: OrgNameRef[],
): string {
  const org = orgs.find(
    (candidate) =>
      candidate.id === role.org_id && candidate.category === role.org_category,
  );
  if (org) {
    return `${org.name} (${org.category}) · ${role.role}`;
  }
  return role.role;
}
